import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { trackPageView } from "./lib/analytics";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import StickyMobileCTA from "./components/StickyMobileCTA";

import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import PrivacyPage from "./pages/PrivacyPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // Skip tracking the admin dashboard
    if (!pathname.startsWith("/admin")) {
      trackPageView(pathname);
    }
  }, [pathname]);
  return null;
}

function Shell() {
  return (
    <div className="min-h-screen bg-[#F8F7F4] text-[#1A1A1A] flex flex-col">
      <Navbar />
      <div className="flex-1 pb-16 md:pb-0">
        <Routes>
          <Route path="/" element={<Navigate to="/decking-cost-calculator-melbourne" replace />} />
          <Route path="/decking-cost-calculator-melbourne" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Navigate to="/decking-cost-calculator-melbourne" replace />} />
        </Routes>
      </div>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Shell />
    </BrowserRouter>
  );
}
